import { styled } from "@mui/material/styles";
import { Box as MuiBox, Toolbar as MuiToolbar, Typography } from "@mui/material";
import Grid, { GridProps } from "@mui/material/Grid";
import colors from "common/styles/colors";

export const EmptyTitle = styled(Typography)({
  marginTop: '8px',
  marginBottom: '8px',
  textAlign: "center",
  fontWeight: 500,
  fontSize: 14,
});

export const Box = styled(MuiBox)(({ theme }) => ({
  position: "initial",
  flex: "1 1 auto",
  textAlign: "left",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexDirection: "row",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

export const Toolbar = styled(MuiToolbar)({
  borderRadius: "6px 6px 0 0",
  borderBottom: `1px solid ${colors.lightGrey3}`,
  backgroundColor: colors.lightGrey1,
  "@media (min-width: 600px)": {
    padding: "20px",
  },
  paddingTop: "16px",
  paddingBottom: "16px",
  "@media print": {
    display: "none",
  },
});

export const FiltersContainer = styled((props: GridProps) =>
  <Grid spacing={2} alignItems="flex-end" {...props} container />
)(({ theme }) => ({
  marginBottom: 0,
  flexDirection: "row",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    marginBottom: "20px",
  },
}));

export const FilterItem = styled((props: GridProps) =>
  <Grid {...props} item />
)(({ theme }) => ({
  minWidth: 200,
  width: 202,
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));